import React from 'react'
import PropTypes from 'prop-types'
import FAQ from '../../components/FAQ'
import messages from './messages'
import { FormattedMessage } from 'react-intl'

function MealPlansPageFAQ({ questions }) {
  return (
    <section className="mx-auto w-full max-w-968 px-32 pb-64 lg:pb-96">
      <h1 className="mb-36 text-center type-40 lg:type-56">
        <FormattedMessage {...messages.faq_heading}></FormattedMessage>
      </h1>
      <FAQ
        questions={questions.map(({ question, answer }) => ({
          q: question,
          a: [answer],
        }))}
        heading={false}
        bg={false}
        background="white"
      />
    </section>
  )
}

MealPlansPageFAQ.propTypes = {
  questions: PropTypes.array.isRequired,
}

export default MealPlansPageFAQ
